<template>
    <div>
        <UserHeaderAuca/>
        <TabsInfo :all_tabs="all_tabs"/>
    </div>
</template>

<script>
import UserHeaderAuca from "@/pages/Home/PersonalData/UserHeaderAuca";
import TabsInfo from "@/pages/Home/ListGlobalComponents/Tabs/TabsInfo";
export default {
    name: "Page",
    components:{
        TabsInfo,
        UserHeaderAuca,
    },
    computed:{
        user() {
            return this.$store.state.user.user
        },
    },
    created() {
        if (!this.$route.query.profile){
            let queries = { ...this.$route.query, profile:this.user.profileId,  };
            this.$router.replace({ name: this.$route.name, query: queries });
        }
    },
    data(){
        return {
            all_tabs:[
                {
                    label: this.$t('profile'),
                    chapters:[
                        {
                            label: this.$t('personal_information'),
                            path:'personal_data',
                            type:'profile',
                        },
                        {
                            label: this.$t('contact_information'),
                            path:'personal_data',
                            type:'contact_information',
                        },
                        {
                            label: this.$t('education'),
                            path:'personal_data',
                            type:'education',
                        },
                        {
                            label: this.$t('emergency_contacts'),
                            path:'personal_data',
                            type:'emergency_contacts',
                        },
                        {
                            label: this.$t('family_structure'),
                            path:'personal_data',
                            type:'family_structure',
                        },
                    ]
                },
                {
                    label: this.$t('studentOrders'),
                    chapters:[
                        {
                            view: 'table',
                            path:'personal_data',
                            type:'orders',
                            use_number:true,
                        },
                    ]
                }
            ]
        }
    }
};
</script>

<style scoped>

</style>
